import Immutable from 'immutable';
import createReducers from '../utils/createreducer';

import {
    USER_CREATE_REQUEST, USER_CREATE_SUCCESS, USER_CREATE_FAILURE, 
    USER_GET_REQUEST, USER_GET_SUCCESS, USER_GET_FAILURE,
    CHECK_EMAIL_EXISTS_REQUEST, CHECK_EMAIL_EXISTS_SUCCESS, CHECK_EMAIL_EXISTS_FAILURE,
    USER_UPDATE_REQUEST, USER_UPDATE_SUCCESS, USER_UPDATE_FAILURE,
    USER_PROFILE_UPDATE_REQUEST, USER_PROFILE_UPDATE_SUCCESS, USER_PROFILE_UPDATE_FAILURE,
} from '../constants/actionconstants';
import initialStoreState from '../store/initialstorestate';

const initialState = initialStoreState.user;

export default createReducers(initialState, {
    [USER_CREATE_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
            isCreating : true,
            isCreated : false,
            isSaving: true,
            statusText : null,
            username : null
        });
    },
    [USER_CREATE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            isCreating : false,
            isCreated : true,
            isSaving: false,
            username : payload.username,
            statusText : 'Your account has been created.'
        });
    },
    [USER_CREATE_FAILURE] : (state, payload) => {
        return Object.assign({}, state, {
            isCreating : false,
            isCreated : false,
            isSaving: false,
            statusText : payload.statusText,
            username : null
        });
    },
    [USER_PROFILE_UPDATE_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
            isSaving: true,
        })
    },
    [USER_PROFILE_UPDATE_FAILURE] : (state, payload) => {
        return Object.assign({}, state, {
            isSaving: false,
        })
    },
    [USER_PROFILE_UPDATE_SUCCESS] : (state, payload) => { // NOTE!! This is both here and in the Auth reducer. Needed to update the user sub-store after editing when returning to the profile page. (This is probably a hack? In a hurry...)
        return Object.assign({}, state, {
            users: state.users.mergeWith(
                (oldData, newData) => Object.assign(oldData, newData),
                Immutable.Map([[payload.id, payload]])),
            isSaving: false,
        })
    },
    [USER_UPDATE_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
            isSaving: true,
        })
    },
    [USER_UPDATE_FAILURE] : (state, payload) => {
        return Object.assign({}, state, {
            isSaving: false,
        })
    },
    [USER_UPDATE_SUCCESS] : (state, payload) => { // Same as above
        return Object.assign({}, state, {
            users: state.users.mergeWith(
                (oldData, newData) => Object.assign(oldData, newData),
                Immutable.Map([[payload.id, payload]])),
            isSaving: false,
        })
    },
    [USER_GET_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            users: state.users.mergeWith(
                (oldData, newData) => Object.assign(oldData, newData),
                Immutable.Map([[payload.id, payload]]))
        })
    },
    [USER_GET_FAILURE] : (state, payload) => {
        return Object.assign({}, state, {
            statusText : payload.statusText,
            status : payload.status
        });
    },
    [CHECK_EMAIL_EXISTS_REQUEST] : (state) => {
        return  Object.assign({}, state, {
            emailExists : {name: null, exists: false}
        })
    },
    [CHECK_EMAIL_EXISTS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            emailExists : {name: payload.name, exists: payload.exists}
        });                                                 
    },
    [CHECK_EMAIL_EXISTS_FAILURE] : (state, payload) => {
        return Object.assign({}, state, {
            emailExists : {name: null, exists: false},
            statusText : payload.statusText,
            status : payload.status
        });
    },
});


// WEBPACK FOOTER //
// ./src/client/src/reducers/user.js